export default "__VITE_ASSET__e987454f__"